var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5754 27.9998C52.04 27.9998 52.4182 27.6229 52.4015 27.1586C52.2067 21.7563 50.1408 16.5788 46.543 12.5207C42.7589 8.2524 37.5423 5.51812 31.8792 4.83462C26.2161 4.15112 20.4988 5.56575 15.8078 8.81116C11.1168 12.0566 7.77718 16.9079 6.42003 22.4483C5.06288 27.9887 5.78225 33.8344 8.44219 38.8804C11.1021 43.9265 15.5184 47.8234 20.8562 49.8346C26.1941 51.8459 32.0838 51.8322 37.4122 49.796C42.4783 47.8602 46.7032 44.2237 49.3728 39.523C49.6022 39.119 49.441 38.6099 49.029 38.3952C48.617 38.1805 48.1104 38.3414 47.8798 38.7448C45.4011 43.0811 41.4935 46.4354 36.8117 48.2244C31.8675 50.1137 26.4024 50.1265 21.4494 48.2602C16.4965 46.394 12.3987 42.7781 9.93053 38.0959C7.46238 33.4137 6.79488 27.9895 8.05418 22.8486C9.31347 17.7077 12.4123 13.2062 16.7651 10.1948C21.1178 7.18337 26.4229 5.87074 31.6776 6.50496C36.9324 7.13917 41.7728 9.6763 45.2841 13.6368C48.609 17.3871 50.5239 22.1677 50.7179 27.1587C50.7359 27.6229 51.1108 27.9998 51.5754 27.9998Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.583 28L25.583 35L39.583 21",
    stroke: "#7663EB",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check-success.1aac2c617527ea1468a117e9fa66992f.svg";
export { ForwardRef as ReactComponent };